import { render, staticRenderFns } from "./administracion.vue?vue&type=template&id=04e07f42&scoped=true&"
import script from "./administracion.vue?vue&type=script&lang=ts&"
export * from "./administracion.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04e07f42",
  null
  
)

export default component.exports